import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {CompetitorStandingsPageConfig} from "./competitor.standings-page.config";
import {CompetitorStandingsPageHandlers} from "./handlers/competitor.standings-page.handlers";
import {CompetitorStandingsPageStore} from "./competitor.standings-page.store";

export class CompetitorStandingsPageController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, CompetitorStandingsPageConfig, CompetitorStandingsPageStore, CompetitorStandingsPageHandlers];

}
